<template>
  <div class="masterdata-right">
    <div class="masterdata-table">
      <table class="table-db table-db-hover">
        <thead>
          <tr>
            <th v-if="isEdit" class="editRow"></th>
            <th @click="sort('id')">
              id
              <i :class="currentSort === 'id'
                ? currentSortDir === 'desc'
                  ? 'fas fa-long-arrow-alt-down'
                  : 'fas fa-long-arrow-alt-up'
                : 'fas fa-arrows-alt-v'
                "></i>
            </th>
            <th @click="sort('kode')">
              Kode
              <i :class="currentSort === 'kode'
                ? currentSortDir === 'desc'
                  ? 'fas fa-long-arrow-alt-down'
                  : 'fas fa-long-arrow-alt-up'
                : 'fas fa-arrows-alt-v'
                "></i>
            </th>
            <th @click="sort('badan_usaha')">
              Badan Usaha
              <i :class="currentSort === 'badan_usaha'
                ? currentSortDir === 'desc'
                  ? 'fas fa-long-arrow-alt-down'
                  : 'fas fa-long-arrow-alt-up'
                : 'fas fa-arrows-alt-v'
                "></i>
            </th>
            <th @click="sort('nama_perusahaan')">
              Nama Perusahaan
              <i :class="currentSort === 'nama_perusahaan'
                ? currentSortDir === 'desc'
                  ? 'fas fa-long-arrow-alt-down'
                  : 'fas fa-long-arrow-alt-up'
                : 'fas fa-arrows-alt-v'
                "></i>
            </th>
            <th @click="sort('updatedAt')">
              Last Modified Date
              <i :class="currentSort === 'updatedAt'
                ? currentSortDir === 'desc'
                  ? 'fas fa-long-arrow-alt-down'
                  : 'fas fa-long-arrow-alt-up'
                : 'fas fa-arrows-alt-v'
                "></i>
            </th>
            <th @click="sort('update_by')">
              Last Modified By
              <i :class="currentSort === 'update_by'
                ? currentSortDir === 'desc'
                  ? 'fas fa-long-arrow-alt-down'
                  : 'fas fa-long-arrow-alt-up'
                : 'fas fa-arrows-alt-v'
                "></i>
            </th>
            <th @click="sort('active')">
              active
              <i :class="currentSort === 'active'
                ? currentSortDir === 'desc'
                  ? 'fas fa-long-arrow-alt-down'
                  : 'fas fa-long-arrow-alt-up'
                : 'fas fa-arrows-alt-v'
                "></i>
            </th>
            <th @click="sort('note')">
              catatan
              <i :class="currentSort === 'note'
                ? currentSortDir === 'desc'
                  ? 'fas fa-long-arrow-alt-down'
                  : 'fas fa-long-arrow-alt-up'
                : 'fas fa-arrows-alt-v'
                "></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td v-if="isEdit" class="editRow" @click="editRow(list)">
              <span class="fa fa-edit pointer ml20"></span>
            </td>
            <td>{{ index + 1 }}</td>
            <td>{{ list.kode }}</td>
            <td>{{ list.badan_usaha }}</td>
            <td>{{ list.nama_perusahaan }}</td>
            <td>{{ list.updatedAt }}</td>
            <td>{{ $get(list, 'user.name', '-') }}</td>
            <td :style="list.active ? 'color:green' : 'color:red'">
              {{ list.active ? 'active' : 'inactive' }}
            </td>
            <td>{{ list.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <TipeBisnisUnit v-if="showModalEdit" :editData="editData" @closeModal="closeModal" :content="content"
      class="notAll" />
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '../../../../services/config'
export default {
  components: {
    TipeBisnisUnit: () =>
      import('@/views/MasterData/Edit/SAP/TipeBisnisUnit.vue'),
  },

  props: {
    isEdit: Boolean,
    content: String,
  },
  data() {
    return {
      currentSort: '',
      currentSortDir: '',
      arrow: false,
      showModalEdit: false,
      editData: {
        id: '',
        kode: '',
        badan_usaha: '',
        nama_perusahaan: '',
        updatedAt: '',
        update_by: '',
        active: '',
        note: '',
      },
      data_bisnis: [],
      data_bce: [
        {
          id: 1,
          kode: '1000',
          badan_usaha: 'PT',
          nama_perusahaan: 'Berau Coal Energy',
          updatedAt: '28/12/2021 07:21',
          update_by: 'System',
          active: 'Active',
          note: 'Test 1',
        },
        {
          id: 2,
          kode: '2100',
          badan_usaha: 'PT',
          nama_perusahaan: 'Mutiara Tanjung Lestari',
          updatedAt: '28/12/2021 07:21',
          update_by: 'System',
          active: 'Active',
          note: 'Test 2',
        },
        {
          id: 3,
          kode: '3000',
          badan_usaha: 'PT',
          nama_perusahaan: 'Berau Coal',
          updatedAt: '28/12/2021 07:21',
          update_by: 'System',
          active: 'Active',
          note: 'Test 3',
        },
        {
          id: 4,
          kode: '3100',
          badan_usaha: 'PT',
          nama_perusahaan: 'Kirana Berau',
          updatedAt: '28/12/2021 07:21',
          update_by: 'System',
          active: 'Active',
          note: 'Test 4',
        },
      ],

      data_bkes: [
        {
          id: '1',
          kode: '2000',
          badan_usaha: 'ALL',
          nama_perusahaan: 'ALL Company',
          updatedAt: '-',
          update_by: 'System',
          active: 'Active',
          note: '-',
        },
        {
          id: '2',
          kode: '7002',
          badan_usaha: 'PT',
          nama_perusahaan: 'Golden Energy Mines',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
        {
          id: '3',
          kode: '7003',
          badan_usaha: 'PT',
          nama_perusahaan: 'Borneo Indobara',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
        {
          id: '4',
          kode: '7004',
          badan_usaha: 'PT',
          nama_perusahaan: 'Kuansing Inti Makmur',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
        {
          id: '5',
          kode: '7005',
          badan_usaha: 'PT',
          nama_perusahaan: 'Trisula Kencana Sakti',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
        {
          id: '6',
          kode: '7007',
          badan_usaha: 'PT',
          nama_perusahaan: 'Bungo Bara Utama',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
        {
          id: '7',
          kode: '7008',
          badan_usaha: 'PT',
          nama_perusahaan: 'Tanjung Belit Bara Utama',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
        {
          id: '8',
          kode: '7009',
          badan_usaha: 'PT',
          nama_perusahaan: 'Karya Cemerlang Persa',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
        {
          id: '9',
          kode: '7010',
          badan_usaha: 'PT',
          nama_perusahaan: 'Berkat Nusantara Perm',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
        {
          id: '10',
          kode: '7011',
          badan_usaha: 'PT',
          nama_perusahaan: 'Citra Alam Indah',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
      ],

      data_gems: [
        {
          id: '1',
          kode: '2000',
          badan_usaha: 'ALL',
          nama_perusahaan: 'ALL Company',
          updatedAt: '-',
          update_by: 'System',
          active: 'Active',
          note: '-',
        },
        {
          id: '2',
          kode: '7002',
          badan_usaha: 'PT',
          nama_perusahaan: 'Golden Energy Mines',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
        {
          id: '3',
          kode: '7003',
          badan_usaha: 'PT',
          nama_perusahaan: 'Borneo Indobara',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
        {
          id: '4',
          kode: '7004',
          badan_usaha: 'PT',
          nama_perusahaan: 'Kuansing Inti Makmur',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
        {
          id: '5',
          kode: '7005',
          badan_usaha: 'PT',
          nama_perusahaan: 'Trisula Kencana Sakti',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
        {
          id: '6',
          kode: '7007',
          badan_usaha: 'PT',
          nama_perusahaan: 'Bungo Bara Utama',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
        {
          id: '7',
          kode: '7008',
          badan_usaha: 'PT',
          nama_perusahaan: 'Tanjung Belit Bara Utama',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
        {
          id: '8',
          kode: '7009',
          badan_usaha: 'PT',
          nama_perusahaan: 'Karya Cemerlang Persa',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
        {
          id: '9',
          kode: '7010',
          badan_usaha: 'PT',
          nama_perusahaan: 'Berkat Nusantara Perm',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
        {
          id: '10',
          kode: '7011',
          badan_usaha: 'PT',
          nama_perusahaan: 'Citra Alam Indah',
          updatedAt: '-',
          update_by: 'System',
          active: 'Inactive',
          note: '-',
        },
      ],
      data_sun: [
        {
          id: '1',
          kode: '4000',
          badan_usaha: 'PT',
          nama_perusahaan: 'PT.',
          updatedAt: '-',
          update_by: 'System',
          active: 'Active',
          note: '-',
        },
      ],
    }
  },

  created() {
    this.$store.dispatch('mdDatabaseStore/getCompanyCode', `bisnis_unit_id=1`)
  },

  methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    editRow(data) {
      this.editData = {
        id: data.id,
        kode: data.kode,
        badan_usaha: data.badan_usaha,
        nama_perusahaan: data.nama_perusahaan,
        updatedAt: data.updatedAt,
        update_by: data.update_by,
        active: data.active,
        note: data.note,
        bisnis_unit_id: data.bisnis_unit_id,
      }
      this.showModalEdit = true
    },
    closeModal() {
      this.showModalEdit = false
    },
    async showData() {
      try {
        let data = []
        let bisnisUnit = this.bisnisUnitData.filter(
          list => list.name == this.content
        )[0]

        data = await this.$store.dispatch(
          'mdDatabaseStore/getCompanyCode',
          `bisnis_unit_id=${bisnisUnit.id}`
        )


        this.data_bisnis = data
      } catch (err) {
      }
    },
  },

  computed: {
    bisnisUnitData() {
      const result = this.$store.state.mdDatabaseStore.bisnisUnitData
      return result
    },
    companyCodeData() {
      const result = this.$store.state.mdDatabaseStore.companyCodeData
      return result
    },


    sortedData() {
      return this.companyCodeData.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    },
  },

  watch: {
    content(value) {
      let bisnisUnit = this.bisnisUnitData.filter(list => list.name == value)[0]

      this.$store.dispatch(
        'mdDatabaseStore/getCompanyCode',
        `bisnis_unit_id=${bisnisUnit.id}`
      )
    },
  },
}
</script>
